import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import SvgPlus from '@icons/plus.svg?react';
import SvgEdit from '@icons/chevron.svg?react';

interface TagItem {
  key: string;
  filled: boolean;
  element: React.ReactNode;
}

interface TagHiderProps {
  tags: TagItem[];
  showAllByDefault: boolean;
}

const TagHider: React.FC<TagHiderProps> = ({ tags, showAllByDefault }) => {
  const { tr } = useTranslationLgs();
  const [showAll, setShowAll] = useState(showAllByDefault);
  const hiddenCount = tags.filter(t => !t.filled).length;

  return (
    <>
      {tags.map(tag =>
        (showAll || tag.filled) ? <React.Fragment key={tag.key}>{tag.element}</React.Fragment> : null,
      )}
      {(hiddenCount > 0 && !showAll) && (
        <div className={'inline-block'} onClick={() => setShowAll(!showAll)}>
          <summary
            className={'flex list-none rounded-lg px-3 py-1.5 gap-3 items-center content-center border border-solid border-content-secondary cursor-pointer font-medium bg-content-quaternary h-12'}
          >
            <div className="text-content-secondary"><SvgPlus /></div>
            <div
              className={'text-content-secondary font-dm-sans text-[14px] font-medium leading-normal tracking-[-0.14px]'}>{tr(`TagHiderTag.title`, `Not filled {{count}}`, { count: hiddenCount })}</div>
            <div className="text-content-brand"><SvgEdit /></div>
          </summary>
        </div>
      )}

    </>
  );
};

export default TagHider;